import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { accidentFromApiMapper } from '@shared/utils/mappers/geo-api-map';
import {
  GeometryTypeEnum,
  ILayerModel,
} from '@types-custom/models/business/marker.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AccidentService {
  constructor(
    private httpClient: HttpClient,
    @Inject('environment') private environment: any
  ) {}

  getAccidentGeoJson(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.environment.baseStaticLayerUrl}/0/query?where=1%3D1&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&distance=&units=esriSRUnit_Foot&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&historicMoment=&returnDistinctValues=false&resultOffset=&resultRecordCount=&returnExtentOnly=false&datumTransformation=&parameterValues=&rangeValues=&quantizationParameters=&featureEncoding=esriDefault&f=geojson`
    );
  }

  getAccidentMapper(accidentSource: any): ILayerModel[] {
    const layer: ILayerModel[] = [];

    const pointsGroupedByCoordinates = this.groupSourceByCoordinates(
      accidentSource.features
    );

    const source: any = {
      type: 'FeatureCollection',
      features: pointsGroupedByCoordinates,
    };

    const accidentPoints = source.features.map((e: any) =>
      accidentFromApiMapper(e)
    );

    layer.push({
      marker: accidentPoints,
      geometryType: GeometryTypeEnum.Point,
      feature: source,
      visibility: true,
    });

    return layer;
  }

  groupSourceByCoordinates(source: any): any[] {
    const mappedresult = source.reduce(function (r: any, a: any) {
      const key = a.geometry.coordinates[0] + '_' + a.geometry.coordinates[1];
      r[key] = r[key] || [];
      r[key].push(a.properties);
      return r;
    }, Object.create(null));

    const points = [];

    for (const [key, value] of Object.entries(mappedresult)) {
      const point = {
        type: 'Feature',
        geometry: { type: 'Point', coordinates: key.split('_') },
        properties: value,
      };
      points.push(point);
    }
    return points;
  }
}

